import * as APIModels from "../../../models";
import { useState, useEffect } from "react";
import { DataService } from "../../../services/DataService";
import DocumentTypeRuleModal from "./modals/DocumentTypeRuleModal";
import { ClientService } from "../../../services/ClientService";
import AuthLayout from "../../../layouts/auth-layout";

export default function Pleadings({
    submission,
    originalDocs,
    onSelectDocument,
    onUpdateDoc,
}: {
    submission: APIModels.Submission;
    originalDocs: APIModels.Document[];
    onSelectDocument: (doc: APIModels.Document, index: number) => void;
    onUpdateDoc: (doc: APIModels.Document) => void;
}) {
    const docTypes: APIModels.DocumentType[] = [];
    const [documentTypes, setDocumentTypes] = useState(docTypes);
    const [selectedDocument, setSelectedDocument] = useState(
        new APIModels.Document()
    );
    const [caseData, setCaseData] = useState(
        submission.caseData ?? new APIModels.CaseData()
    );
    const [documents, setDocuments] = useState(originalDocs);
    const [activeRow, setActiveRow] = useState(-1);
    const [filterText, setFilterText] = useState("");
    const [loadingArray, setLoadingArray] = useState([] as boolean[]);

    const [ruleModalShow, setRuleModalShow] = useState(false);

    const predictFunction = async (index: number, doc: APIModels.Document) => {
        if (
            (caseData?.caseSubTypeID ?? caseData?.caseTypeID) !=
                APIModels.EmptyGuid ||
            (caseData?.ucn && caseData.ucn.length > 4)
        ) {
            const docs = [];
            docs.push(doc);
            console.log(loadingArray);
            ClientService.getDocType({
                body: {
                    docs: docs,
                    attorneyID: submission.attorneyID,
                    submissionID: submission.id,
                    caseTypeID:
                        submission.filename!.indexOf("-o-0") > -1
                            ? APIModels.EmptyGuid
                            : caseData?.caseSubTypeID ?? caseData?.caseTypeID,
                    claimAmount: caseData?.claimAmount
                        ? parseFloat(
                              caseData?.claimAmount
                                  .replace(",", "")
                                  .replace("$", "")
                          )
                        : caseData?.smallClaimsAmount,
                    countyID: caseData?.countyID,
                    divisionID: caseData?.divisionID,
                    newCase: submission.filename!.indexOf("a-0") > -1,
                },
            })
                .then(
                    (resp) => {
                        if (
                            resp.successful === true &&
                            resp.data &&
                            resp.data[0]?.documentTypeID &&
                            !documents[index].documentTypeID
                        ) {
                            // const updatedDoc = {
                            //      ...doc,
                            //      documentTypeID: resp.data[0]?.documentTypeID,
                            //      documentType: resp.data[0]?.documentType,
                            //   };
                            //const updatedDocs = [...documents];
                            //updatedDocs.splice(index, 1, updatedDoc);
                            //setDocuments(updatedDocs);

                            const updatedDoc = {
                                ...doc,
                                documentType: resp.data[0]?.documentType,
                                documentTypeID: resp.data[0]?.documentTypeID,
                            };
                            onUpdateDoc(updatedDoc);
                        }
                    },
                    (error) => {
                        console.log(error);
                    }
                )
                .finally(() => {
                    const temp = [...loadingArray];
                    temp.splice(index, 1, false);
                    setLoadingArray(temp);
                });
        }
    };

    useEffect(() => {
        //setDocuments(submission.documents ?? []);
        setCaseData(submission.caseData ?? new APIModels.CaseData());
        console.log({ isOrder: submission.filename!.indexOf("-o-0") > -1 });
        if (submission.filename!.indexOf("-o-0") > -1) {
            DataService.getDocumentTypesByCounty({
                countyId: submission.caseData?.countyID ?? "",
            }).then(
                (resp) => {
                    setDocumentTypes(resp);
                },
                (error) => {
                    console.log(error);
                }
            );
        } else {
            console.log(
                "attorneyTypeKey: " + submission.attorney?.attorneyTypeKey
            );
            DataService.getDocumentTypes({
                countyId: submission.caseData?.countyID ?? "",
                caseTypeId:
                    submission.caseData?.caseSubTypeID != APIModels.EmptyGuid
                        ? submission.caseData!.caseSubTypeID!
                        : submission.caseData?.caseTypeID ?? "",
                attorneyType: (submission.attorney?.attorneyTypeKey ??
                    1) as APIModels.AttorneyTypeKeys,
            }).then(
                (resp) => {
                    setDocumentTypes(resp);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [submission]);

    useEffect(() => {
        console.log(caseData?.division);
    }, [caseData]);

    useEffect(() => {
        console.log("doc types updated");
        const defaultLoading = submission.documents?.map(() => true);
        setLoadingArray(defaultLoading ?? []);
        documents?.forEach(
            (v, i) => !v.documentTypeID && predictFunction(i, v)
        );
    }, [documentTypes]);

    const onSelectDocType = (
        docType: APIModels.DocumentType,
        doc: APIModels.Document,
        index: number
    ) => {
        setSelectedDocument(doc);

        const updatedDoc = {
            ...doc,
            documentType: docType.name,
            documentTypeID:
                docType.id !== APIModels.EmptyGuid
                    ? docType.id ?? docType.ePortalID
                    : docType.ePortalID,
        };
        onUpdateDoc(updatedDoc);
        //setActiveRow(-1);
    };

    const onSelectDocTypeById = (
        docTypeId: string,
        doc: APIModels.Document,
        index: number
    ) => {
        setSelectedDocument(doc);
        const docTypesFound = documentTypes.filter(
            (d) => d.ePortalID == docTypeId
        );
        if (docTypesFound && docTypesFound.length === 1) {
            const docType = docTypesFound[0];
            const updatedDoc = {
                ...doc,
                documentType: docType.name,
                documentTypeID:
                    docType.id !== APIModels.EmptyGuid
                        ? docType.id ?? docType.ePortalID
                        : docType.ePortalID,
            };
            onUpdateDoc(updatedDoc);
        } else {
            console.log(
                "No doc type found matching " +
                    docTypeId +
                    " result " +
                    docTypesFound.length
            );
            console.log(docTypes);
        }
    };

    const openRuleModal = (doc: APIModels.Document) => {
        setSelectedDocument(doc);
        setRuleModalShow(true);
    };

    if (!submission.documents) return <div></div>;

    return (
        <div className="mb-3">
            {ruleModalShow && (
                <DocumentTypeRuleModal
                    show={ruleModalShow}
                    attorneyId={submission.attorneyID ?? ""}
                    county={caseData?.county}
                    division={caseData?.division}
                    document={selectedDocument}
                    filingCode={""}
                    filingComponent={""}
                    securityType={""}
                    portalIdentifier={submission.portalIdentifier!}
                    onSave={() => setRuleModalShow(false)}
                    onClose={() => setRuleModalShow(false)}
                />
            )}
            {documents?.map((doc, i) => {
                return (
                    <>
                        <div className="row">
                            <div
                                className="col-sm-12"
                                style={{
                                    height: 40,
                                    verticalAlign: "center",
                                    lineHeight: "40px",
                                    overflow: "hidden",
                                }}
                            >
                                <span
                                    style={{
                                        fontWeight: "bold",
                                    }}
                                >{`${i + 1}) `}</span>
                                {doc.filename}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-5">
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        float: "right",
                                        overflow: "hidden",
                                    }}
                                >
                                    {doc.documentTypeID && doc.documentType ? (
                                        doc.documentType
                                    ) : doc.predictedType &&
                                      doc.predictedTypeID ? (
                                        <a
                                            href="#!"
                                            onClick={() =>
                                                onSelectDocTypeById(
                                                    doc.predictedTypeID ?? "",
                                                    doc,
                                                    i
                                                )
                                            }
                                        >
                                            {doc.predictedType}
                                        </a>
                                    ) : (
                                        doc.predictedType
                                    )}
                                </span>
                            </div>
                            <div className="col-5">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={doc.documentType}
                                    style={
                                        doc.documentTypeID
                                            ? styles.valid
                                            : styles.missing
                                    }
                                    id={`doc-input-${i}`}
                                    aria-describedby="inputGroupPrepend"
                                    onFocus={() => {
                                        setSelectedDocument(doc);
                                        onSelectDocument(doc, i);
                                    }}
                                    onChange={(e) => {
                                        doc.documentType =
                                            e.currentTarget.value;

                                        const temp = [...documents];
                                        temp.splice(i, 1, doc);

                                        setDocuments([...temp]);
                                    }}
                                    onKeyDown={() =>
                                        activeRow !== i
                                            ? setActiveRow(-1)
                                            : setActiveRow(i)
                                    }
                                    onKeyUp={(e) => {
                                        setActiveRow(i);
                                        setFilterText(e.currentTarget.value);
                                    }}
                                    required
                                />
                            </div>
                            <div className="col-1">
                                <button
                                    tabIndex={-1}
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={() => openRuleModal(doc)}
                                >
                                    +
                                </button>
                            </div>
                            <div className="col-1">
                                {loadingArray.length < i && loadingArray[i] && (
                                    <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            {documentTypes &&
                                activeRow === i &&
                                documentTypes.map((dt, di) =>
                                    filterText.length > 0 &&
                                    dt
                                        .name!.toLowerCase()
                                        .indexOf(filterText.toLowerCase()) >=
                                        0 ? (
                                        <div
                                            className="col-6"
                                            style={{ marginBottom: 5 }}
                                        >
                                            <div className="row">
                                                <div className="col-sm-1">
                                                    <input
                                                        id={
                                                            dt.ePortalID ??
                                                            di.toString()
                                                        }
                                                        type="radio"
                                                        onChange={() =>
                                                            onSelectDocType(
                                                                dt,
                                                                doc,
                                                                i
                                                            )
                                                        }
                                                        value={dt.id}
                                                        name={`doc-type${i}`}
                                                    />
                                                    &nbsp;
                                                </div>
                                                <div
                                                    className="col-sm-11"
                                                    style={{
                                                        width: "auto",
                                                        maxWidth: "90%",
                                                    }}
                                                >
                                                    <label
                                                        htmlFor={
                                                            dt.ePortalID ??
                                                            di.toString()
                                                        }
                                                    >
                                                        {dt.name}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )
                                )}
                        </div>
                    </>
                );
            })}
        </div>
    );
}

const styles = {
    missing: {
        border: "2px solid #ff0000",
    },
    valid: {
        border: "2px solid #00ff00",
    },
    warning: {
        border: "2px solid #FFFF00",
    },
};
